module.exports = __webpack_public_path__ + "img/fondo-full-guido.74645e57.png";